type ResourceRef = { resource: string; resourceId: string };

/** 0 View, 1 Save Draft and Submit, 2 Publish. Null for every other resource. */
function expertAnswerLevel({ resource, resourceId }: ResourceRef): number | null {
  const id = resourceId.toLowerCase();
  const name = resource.toLowerCase();
  const isExpert = id === 'expert_answer' || id.startsWith('expert_answer_') || name.startsWith('expert answer');
  if (!isExpert) return null;
  if (id.includes('publish') || name.includes('publish')) return 2;
  if (id.includes('submit') || id.includes('draft') || name.includes('submit') || name.includes('draft')) return 1;
  if (id === 'expert_answer' || name.includes('view')) return 0;
  return null;
}

export function orderApplicationResources<T extends ResourceRef>(resources: T[]): T[] {
  const levels = resources.map(expertAnswerLevel);
  const expert = resources
    .filter((_, index) => levels[index] !== null)
    .sort((a, b) => (expertAnswerLevel(a) ?? 0) - (expertAnswerLevel(b) ?? 0));
  if (!expert.length) return resources;

  let placed = false;
  return resources.flatMap((resource, index) => {
    if (levels[index] === null) return [resource];
    if (placed) return [];
    placed = true;
    return expert;
  });
}

export function applyApplicationResourceToggle<T extends ResourceRef & { hasView: boolean }>(
  resources: T[],
  resourceId: string,
  enabled: boolean
): T[] {
  const target = resources.find((resource) => resource.resourceId === resourceId);
  if (!target) return resources;
  const level = expertAnswerLevel(target);
  return resources.map((resource) => {
    if (level === null) {
      return resource.resourceId === resourceId ? { ...resource, hasView: enabled } : resource;
    }
    const rowLevel = expertAnswerLevel(resource);
    if (rowLevel !== null && (enabled ? rowLevel <= level : rowLevel >= level)) {
      return { ...resource, hasView: enabled };
    }
    return resource;
  });
}
